import React from "react";
import "../../Components/ChartPage/Chartpage.css";
import { Table } from "react-bootstrap";
import { Tooltip } from "@mui/material";
import Loading from "../Spinner.js";

import {
  FaArrowUp,
  FaArrowDown,
  FaTrash,
  FaDownload,
  FaRedo,
  FaInfoCircle,
} from "react-icons/fa";

export const renderActivityBadge = (label = "") => {
  const lowered = label.toLowerCase();

  let color = "#6c757d";
  let icon = <FaInfoCircle />;
  if (lowered.includes("uninstalled")) {
    color = "#dc3545";
    icon = <FaTrash />;
  } else if (lowered.includes("installed")) {
    color = "#28a745";
    icon = <FaDownload />;
  } else if (lowered.includes("re-activated")) {
    color = "#ffc107";
    icon = <FaRedo />;
  } else if (lowered.includes("upgraded")) {
    color = "#007bff";
    icon = <FaArrowUp />;
  } else if (lowered.includes("downgraded")) {
    color = "#fd7e14";
    icon = <FaArrowDown />;
  }

  return (
    <span
      className="badge d-flex align-items-center gap-1"
      style={{
        backgroundColor: color,
        color: "#fff",
        padding: "5px 10px",
        borderRadius: "20px",
        fontSize: "0.75rem",
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
        whiteSpace: "nowrap",
      }}
    >
      {icon} {label}
    </span>
  );
};

const Tablelist = (props) => {
  const { loading, tabledata } = props;

  return (
    <div className="table-responsive 33333">
      <Table>
        <thead>
          <tr>
            {tabledata.thead.map((cell, index) => (
              <th key={index} className="border border-light">
                {cell.title}
              </th>
            ))}
          </tr>
        </thead>

        {/* tbody: conditionally render spinner or rows */}
        <tbody>
          {loading ? (
            // Spinner row spanning all columns
            <tr>
              <td colSpan={tabledata.thead.length} className="text-center py-5">
                <Loading />
              </td>
            </tr>
          ) : tabledata.tbody.length > 0 &&
            !tabledata.tbody.every((row) => row.dummy === true) ? (
            // Render actual rows
            tabledata.tbody.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {tabledata.thead.map((cell, cellIndex) => (
                  <td key={cellIndex}>
                    {cell.type === "index" && rowIndex + 1}

                    {cell.type === "thumbnail" && row[cell.image] && (
                      <img
                        style={{ width: "45px", height: "45px" }}
                        src={`https://flagcdn.com/${row[cell.image]}.svg`}
                        alt="thumbnail"
                      />
                    )}

                    {cell.type === "link" && row[cell.element?.key] && (
                      <a
                        target="_blank"
                        title={row[cell.element.key]}
                        rel="noopener noreferrer"
                        href={`https://${row[cell.element.url]}`}
                      >
                        {row[cell.element.key] || "--"}
                      </a>
                    )}

                    {cell.type === "text" && (
                      <>
                        {cell.key === "activityType"
                          ? row[cell.key]
                            ? renderActivityBadge(row[cell.key])
                            : "--"
                          : row[cell.key] !== null &&
                            row[cell.key] !== undefined &&
                            row[cell.key] !== ""
                          ? row[cell.key]
                          : "--"}
                      </>
                    )}

                    {cell.type === "action" && (
                      <span style={{ cursor: "pointer" }}>
                        {cell.element.map((type, index) => {
                          if (type.type === "edit") {
                            return (
                              <span
                                key={index}
                                className="edit-icon"
                                onClick={(e) =>
                                  type.action(e, row["app_install_id"])
                                }
                              >
                                {type.icon}
                              </span>
                            );
                          } else if (
                            type.type === "view" ||
                            type.type === "viewfilter"
                          ) {
                            return (
                              <Tooltip key={index} title={type.type}>
                                <i
                                  onClick={(e) =>
                                    type.type === "view"
                                      ? type.action(e, row["app_install_id"])
                                      : type.action(e, row)
                                  }
                                >
                                  {type.icon}
                                </i>
                              </Tooltip>
                            );
                          }
                          return null;
                        })}
                      </span>
                    )}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            // No records found row
            <tr className="text-center no-data">
              <td colSpan={tabledata.thead.length}>NO RECORD FOUND!</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default Tablelist;
